import { css } from "@microsoft/fast-element";
import { fillColor, getToken } from '../../design-tokens';
import { elevationRule } from '../../styles/elevation';
import { paddingNumber } from '../../styles/size';

export const dialogStyles = css`
    :host {
        --elevation: ${getToken('space-high-elevation')};
    }

    .control {
        position: relative;
        display: flex;
        flex-direction: column;
        ${elevationRule}
        min-width: var(--dialog-width);
        min-height: var(--dialog-height);
        background-color: ${fillColor};
        z-index: 1;
        border-radius: calc(${getToken('space-corner-radius')} * 1px);
        border: calc(${getToken('space-stroke-width')} * 1px) solid transparent;
    }

    .title {
        display: none;
    }

    :host(.has-title) .title {
        display: flex;
        gap: calc(${paddingNumber} * 1px);
        padding: calc(${getToken('space-design-unit')} * 1px) calc(${paddingNumber} * 1px);
        background: var(--ui-banner-color-background);
        color: var(--ui-banner-color-text);
    }

    :host(.has-title) .content {
        margin-top: calc(${getToken('space-form-field-gap-units')} * 1px);
    }

    .close-button {
        margin-inline-start: auto;
        color: var(--ui-banner-color-text);
    }

    .content {
        margin: calc(${paddingNumber} * 1px);
    }

    :host(.has-actions) .actions {
        display: flex;
        justify-content: flex-end;
        margin: calc(${paddingNumber} * 1px);
        margin-top: 0;
    }
`;

export const modalStyles = css`
    :host {
        --dialog-height: 120px;
        --dialog-width: 240px;
        display: block;
    }

    :host([hidden]) {
        display: none;
    }

    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.3);
        touch-action: none;
    }

    .positioning-region {
        display: flex;
        justify-content: center;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: auto;
        z-index: 10;
    }

    .control {
        margin-top: auto;
        margin-bottom: auto;
    }

    ${dialogStyles}
`;
